import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import verifiedBadge from '../../../Badges/Verified/verified.png';
import styles from '../Onboarding.module.scss';

const VERIFY_PATH = '/apply-for-verification';

const VerificationBanner = ({ onLearnMore }) => (
  <div className={styles.verificationBanner}>
    <div className={styles.verificationBannerBody}>
      <span className={styles.verificationBannerPill}>
        High score &middot; Profile complete
      </span>

      <h2 className={styles.verificationBannerHeadline}>
        You&rsquo;re ready to get verified
      </h2>
      <p className={styles.verificationBannerText}>
        Build client confidence with a blue tick and featured placement as a{' '}
        <strong>Verified expert</strong> on Twine.
      </p>

      <div className={styles.verificationBannerActions}>
        <Link to={VERIFY_PATH} className={styles.verificationCta}>
          Apply for verification <span aria-hidden="true">&rarr;</span>
        </Link>

        <button
          type="button"
          className={styles.verificationLink}
          onClick={onLearnMore}
        >
          What does verified mean?
        </button>
      </div>
    </div>

    <div className={styles.verificationBannerCard}>
      <img
        src={verifiedBadge}
        alt="Verified"
        className={styles.verificationBannerCardBadge}
      />
      <p className={styles.verificationBannerCardTitle}>Verified</p>
      <p className={styles.verificationBannerCardSubtitle}>
        Trusted freelancer on Twine
      </p>
    </div>
  </div>
);

VerificationBanner.propTypes = {
  onLearnMore: PropTypes.func,
};

export default VerificationBanner;
